import React, {useState} from 'react'
import {push} from 'connected-react-router'
import Modal from 'react-modal'
import {connect} from 'react-redux';
import {
    Header,  
    Button
} from '../../components/RegularComponents'
import {collectorApplicationReviewSelect} from '../../redux/selector/collectorApplicationReviewSelector'
import CollectorDetails from "./AgentDetails"
import LicenceHistoryDetails from '../AgencyLicence/LicenceHistoryDetails'
import LicenceSuspensionDetails from '../AgencyLicence/LicenceSuspensionDetails'
import TopNavigationBar from "../TopNavigationBar"
import { 
    // APPLICATION_MODE_NEW,
    // APPLICATION_MODE_RENEW,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT
} from "../../app/constants"
import Navigation from '../Navigation';
import {replaceUrlParams} from '../../app/utils'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import CriminalHistoryDetails from '../AgencyLicence/CriminalHistoryDetails'
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { setCurrentAgentMortgageProperty } from '../../redux/slice/additionalApplicationsSlice';

const AGENT_APPLICATION_PROPERTY = "userApplicationReviewComplete";

const CollectorApplicationReview = (props) => {
    const {collectorApplicationReview,dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const collectorApplicationReviewViewData = props.collectorApplicationReview[applicationType] ? 
                props.collectorApplicationReview[applicationType] : props.collectorApplicationReview
    const {reviewDetails} = collectorApplicationReview

    const REVIEW_COMPONENT_KEYS = {
        APPLICANT_DETAILS : "applicantDetails",
        CRIMINAL_HISTORY : "criminalHistoryDetails",
        LICENCE_SUSPENSION : "licenceSuspensionDetails",
    } 

    const [editComponent, setEditComponent] = useState(null)
    const [showEditDialog, setShowEditDialog] = useState(false)

    const MainSeparator = () => {
        return(
            <hr 
                className="bottomMarginNormal"
                style={{borderColor : "#777", borderWidth: '3px'}} 
            />
        )
    }

    const SubSeparator = () => {
        return (
            <hr 
                className="bottomMarginNormal"
                style={{borderColor : "#0058a466", 
                        borderWidth: '3px', 
                        width: "60%", 
                        marginLeft: "0px"}} 
            />
        )
    }

    /*=== click handlers == */
    const handleLicenceApplicantDetailsEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.APPLICANT_DETAILS)
    }

    // const handleLicenceHistoryListEdit = () => {
    //     setShowEditDialog(true)
    //     setEditComponent("licenceHistoryDetails")
    // }

    const handleLicenceSuspendedEdit = () => {
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION)
    }

    const handleCriminalHistoryListEdit = () => { 
        setShowEditDialog(true)
        setEditComponent(REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY)
    }

    const titleForComponent = (componentKey) => { 
        switch(componentKey) { 
            case REVIEW_COMPONENT_KEYS.APPLICANT_DETAILS : 
                return "Applicant information"
            case REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY : 
                return "Criminal history"
            case REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION : 
                return "Licence suspension"
            default :
                return ""
        }
    }

    /* == render == */
    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} />
                <div className="row">
                    <Header header={collectorApplicationReviewViewData.header} />
                </div>

                <div className="timeline row bottomMarginMedium">
                    <ol>
                        <li className="timeline-item col-md-12">
                            <div className="step-content col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">1</span>
                                <h3>Applicant Information</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        <ReviewForm data={reviewDetails.applicantDetails} />
                                        <MainSeparator />
                                    </div>
                                    <div className="col-lg-1">
                                        <Button 
                                            id="edit-licence-applicant-details-button"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleLicenceApplicantDetailsEdit}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-item col-md-12">
                            <div className="step-content col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">2</span>
                                <div className="bottomMarginNormal"><h4>Criminal history</h4></div>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {
                                            reviewDetails.criminalHistoryListData.map((criminalData, index) => {
                                                return (
                                                    <div key={"criminal-history-data-" + index}>
                                                        <ReviewForm data={criminalData} />
                                                        {(index < reviewDetails.criminalHistoryListData.length - 1)
                                                            && <SubSeparator />} 
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button 
                                            id="edit-criminal-history-button"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleCriminalHistoryListEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item col-md-12">
                            <div className="step-content step-content-no-border col-md-12 col-xs-12">
                                <span className="step-counter step-counter-circle">3</span>
                                <h3>Licence suspension</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        <ReviewForm data={reviewDetails.licenceSuspendedQuestion} />
                                        {
                                            reviewDetails.licenceSuspendedData.map((data, index) => {
                                                return (
                                                    <div key={"suspension-data" + index}>
                                                        <ReviewForm data={data} />
                                                        {(index < reviewDetails.licenceSuspendedData.length - 1)
                                                            && <SubSeparator />} 
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-1">
                                        <Button 
                                            id="edit-licence-suspended-button"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleLicenceSuspendedEdit}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
                <div className="row bottomMarginMedium">
                    <Button 
                        id="save-and-next-button"
                        buttonType="regular_primary"
                        text={"Save and next"}
                        onClick={() => {
                            let nextUrl = collectorApplicationReviewViewData.navigation.next
                            /* 
                            - The name might be misleading, but below function will save the 
                              said property for the current agent application.
                            */
                            dispatch(
                                setCurrentAgentMortgageProperty({
                                    key: AGENT_APPLICATION_PROPERTY,
                                    value: true,
                                })
                            );

                            dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                                .then(data => {
                                    dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
                                })
                        }}
                    />
                </div>

                <Modal
                    appElement={document.getElementById('root')}
                    isOpen={showEditDialog}
                    contentLabel="editDetailsDialog"
                    onRequestClose={() => { setShowEditDialog(false) }}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    className="modalDialogContent editDetailsModalDialog"
                    closeTimeoutMS={150}>
                        <div className="row">
                            <div className="col-11">
                                <h2>{titleForComponent(editComponent)}</h2>
                                <MainSeparator />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-11">
                                {editComponent === REVIEW_COMPONENT_KEYS.APPLICANT_DETAILS && 
                                    <CollectorDetails 
                                        viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT} 
                                        onEditSave={() => setShowEditDialog(false)}
                                        {...props}
                                />}
                                {editComponent === "licenceHistoryDetails" && 
                                    <>
                                        <LicenceHistoryDetails 
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT} 
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />
                                    </>
                                }
                                {editComponent === REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION && 
                                    <>
                                        <LicenceSuspensionDetails 
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT} 
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />
                                    </>
                                }
                                {editComponent === REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY && 
                                    <>
                                        <CriminalHistoryDetails
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />
                                    </>
                                }
                        </div>
                            <div className="col-1">
                                <div 
                                    className="closeButton pull-right" 
                                    onClick={() => {
                                        setShowEditDialog(false)
                                    }}
                                >
                                    <i className="fa fa-2x fa-times"></i>
                                </div>
                            </div>
                        </div>
                </Modal>
            </div>
        </>
    )
}

export default connect(collectorApplicationReviewSelect) (CollectorApplicationReview)
